
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2048',
  depVersions: {
  "customer-portal-app": "static-1.2048",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.457",
  "data-fetching-client": "static-1.9600",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25139",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5520",
  "hs-test-utils": "static-1.7939",
  "hub-http": "static-1.6146",
  "hub-http-shared-msw-handlers": "static-1.9789",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18020",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11386",
  "I18n": "static-7.1606",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6394",
  "payment-link-components": "static-1.23315",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6912",
  "quartz-core": "static-1.6131",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10135",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5284",
  "rich-text-lib": "static-1.19702",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17877",
  "ui-components-test-utils": "static-1.5524",
  "UIComponents": "static-3.8333",
  "foundations-assets": "static-1.4778",
  "foundations-components": "static-1.7784",
  "foundations-theming": "static-1.4339",
  "foundations-theming-specialty": "static-1.2055",
  "framer-motion": "static-1.70",
  "history": "static-4.47",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.750",
  "quartz-config": "static-1.690",
  "quartz-routing": "static-1.342",
  "quick-fetch": "static-1.3858",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16585",
  "react-router-dom": "static-5.26",
  "rpc-client-utils": "static-1.4570",
  "sanitize-text": "static-1.8070",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4695",
  "ui-addon-react-router-dom": "static-1.9470",
  "usage-tracker": "static-1.7262",
  "usage-tracker-anonymous": "static-1.5679",
  "usage-tracker-core": "static-1.7112",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3343",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3189",
  "quartz-webpack": "static-1.3136",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7586",
  "frontend-preferences-client": "static-1.7851",
  "laboratory-lib": "static-3.7084",
  "onboarding-scopes": "static-1.6390",
  "ui-addon-opt": "static-4.8306",
  "HeadJS": "static-2.737",
  "hs-test-utils-bend-plugin": "static-1.3050",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.24",
  "ts-schema": "static-1.4018",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7639",
  "cssUtils": "static-1.773",
  "customer-data-ui-utilities": "static-1.9752",
  "HubStyle": "static-2.11694",
  "knowledge-content-types": "static-1.8472",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.587",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9812",
  "ui-addon-i18n": "static-1.11076",
  "ui-business-units-lib": "static-1.8968",
  "ui-shepherd-react": "static-3.10074",
  "video-components-external": "static-1.11035",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4250",
  "commerce-tours-lib": "static-1.5956",
  "customer-data-properties": "static-1.51277",
  "getting-started-shared-tasks": "static-1.18283",
  "growth-onboarding-reliability": "static-1.5009",
  "onboarding-tours": "static-1.16460",
  "reference-resolvers-lite": "static-1.8017",
  "sales-checkout-service-client": "static-1.3569",
  "ui-addon-iframeable": "static-1.8977",
  "user-context": "static-1.5026",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.822",
  "hubspotter-http": "static-1.4592",
  "icons": "static-2.640",
  "mobile-manifest-mixins": "static-1.511",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.587",
  "quartz-head": "static-1.577",
  "quartz-test": "static-1.587",
  "quartz-tracking": "static-1.291",
  "ui-fonts": "static-1.648",
  "usage-tracker-container": "static-1.7252",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9355",
  "data-token-picker": "static-1.16273",
  "FileManagerLib": "static-1.39024",
  "property-translator": "static-1.5328",
  "atom": "static-1.4996",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5736",
  "salesImages": "static-1.523",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5267",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1133",
  "bend-plugin-foundations-components": "static-1.4053",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "trellis-assets": "static-1.1601",
  "bend-plugin-foundations-theming": "static-1.2822",
  "foundations-theming-base": "static-1.3324",
  "stylex": "static-1.30",
  "interframe": "static-3.4688",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5676",
  "chirp-fetch": "static-1.1808",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4398",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3093",
  "inbound-db-properties-service-client": "static-1.3782",
  "superstore": "static-1.4694",
  "feedback-loader": "static-1.29161",
  "ai-components-ui-library": "static-1.8752",
  "ui-addon-video-player": "static-1.8622",
  "ui-coaching-tips": "static-1.28329",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4545",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2419",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8094",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4576",
  "content-media-composition-data-lib": "static-1.12006",
  "content-media-compositions": "static-2.16013",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4078",
  "magpie-lib": "static-1.5514",
  "magpie-types": "static-1.4974",
  "media-bridge-lib": "static-1.18796",
  "video-data-lib": "static-1.34693",
  "commerce-products-lib": "static-1.9238",
  "crm-message-bus": "static-1.42776",
  "growth-data-modal": "static-1.5310",
  "hubspot-apollo-client": "static-1.4803",
  "onboarding-tours-client": "static-1.4674",
  "calling-global-api": "static-1.64199",
  "calling-internal-common": "static-1.31227",
  "calling-lifecycle-internal": "static-1.65581",
  "calling-lifecycle-messages": "static-1.57875",
  "conditional-properties-service-client": "static-1.3737",
  "crm-links": "static-1.6205",
  "customer-data-objects-ui-components": "static-1.12946",
  "customer-data-properties-shared-msw-handlers": "static-1.9116",
  "customer-data-property-utils": "static-1.8009",
  "external-options-client-types": "static-1.4099",
  "file-manager-components": "static-1.23384",
  "framework-data-schema-resolvers": "static-1.6801",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.66",
  "inbound-db-meta-service-client": "static-1.3531",
  "inbounddb-objects-service-types": "static-1.4164",
  "meetings-icalendar-utils-lib": "static-1.556",
  "multi-currency-client-types": "static-1.3632",
  "object-builder-ui-client": "static-1.48482",
  "pipeline-validation-client-types": "static-1.3906",
  "property-value-citations": "static-1.1891",
  "pulse": "static-1.472",
  "smart-property-lib": "static-1.6548",
  "tiered-pricing": "static-1.1050",
  "ui-addon-form-validation": "static-1.10916",
  "growth-onboarding-confetti": "static-1.2995",
  "growth-onboarding-next-action-utils": "static-1.1690",
  "navigation-components": "static-1.17764",
  "onboarding-tours-utils": "static-1.526",
  "ui-shepherd-tracker": "static-1.7455",
  "ui-universal-auth": "static-1.8881",
  "batch-promise": "static-1.1478",
  "navigation-messaging": "static-1.7091",
  "getting-started-shared-tasks-store": "static-1.17401",
  "hubspotter-http-shared-msw-handlers": "static-1.9787",
  "usage-tracker-session-replay": "static-1.4948",
  "audio-components": "static-1.5802",
  "FileManagerCore": "static-1.38883",
  "FileManagerImages": "static-1.36535",
  "video-components": "static-1.13038",
  "foundations-components-legacy": "static-1.809",
  "nav-client-types": "static-1.2283",
  "purchase-motions-api": "static-1.5739",
  "self-service-api": "static-1.10171",
  "signup-constants": "static-1.18717",
  "signup-ui-url-generator": "static-2.7959",
  "trials-service-types": "static-1.3827",
  "usage-tracker-public": "static-1.7073",
  "chatspot-core": "static-1.20939",
  "ContentUtils": "static-1.68125",
  "copilot-toolkit": "static-1.10923",
  "growth-onboarding-feedback-components": "static-1.6508",
  "reactive-lib": "static-1.648",
  "simple-logging-lib": "static-1.2976",
  "commerce-permissions": "static-1.691",
  "customer-data-tracking": "static-1.6810",
  "products-iframe-lib": "static-1.7714",
  "products-ui-components-shared-msw-handlers": "static-1.10171",
  "onboarding-data-sync-lib": "static-1.1833",
  "hubspot-apollo-cache": "static-1.262",
  "calling-error-reporting": "static-1.31233",
  "shared-worker-versioning": "static-1.10963",
  "calling-usage-tracker": "static-1.6466",
  "voice-sms-access-library": "static-1.691",
  "conversations-skeleton-state": "static-1.7175",
  "location-customization-utils-lib": "static-1.9011",
  "crm-pipelines-api-client-types": "static-1.4083",
  "framework-builder-read-service-client": "static-1.3950",
  "framework-data-schema-quick-fetch": "static-1.6706",
  "persist-promise": "static-1.3635",
  "directed-graph": "static-1.863",
  "event-emitter": "static-1.873",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.74",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9872",
  "fsm": "static-1.3659",
  "policy-lib": "static-1.6709",
  "react-tinymce": "static-1.55024",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9935",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54150",
  "tinymce-plugins": "static-1.57264",
  "tinymce-themes": "static-1.56120",
  "growth-onboarding-next-action-components": "static-1.1718",
  "user-context-client": "static-1.4537",
  "nest": "static-1.149",
  "unified-auth-core-lib": "static-1.676",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4457",
  "video-embed": "static-1.35527",
  "content-icons-ui": "static-1.2206",
  "social-insights-client-types": "static-1.21860",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4735",
  "integrations-lib": "static-1.15867",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4188",
  "InboxConnectUtils": "static-4.14597",
  "calling-orchestration-schema": "static-1.35468",
  "crm-record-cards-service-types": "static-1.3551",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4443",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2967",
  "tinymce-data": "static-1.40235",
  "ui-addon-sales-email": "static-1.5137",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12299",
  "layout-dnd-utils": "static-1.11274",
  "react-codemirror": "static-1.10549",
  "ui-brand-identity-lib": "static-1.14911",
  "NamespacedHubStyle": "static-2.9005",
  "outpost": "static-1.4116",
  "flux-actions": "static-1.326",
  "integrations-error-boundary-lib": "static-1.13282",
  "integrations-tracking-lib": "static-1.5522",
  "native-integrations-shared-strings": "static-1.7711",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10299",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.395",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68200",
  "layout-data-lib": "static-1.9599",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2934",
  "google-sheets-integration-lib": "static-1.13",
  "microsoft-drive-integration-lib": "static-1.104",
  "advanced-menus-core": "static-1.15012",
  "advanced-menus-lib": "static-1.11967",
  "ExportDialog": "static-6.10317",
  "ui-memberships-settings-lib": "static-1.33833",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15011",
  "simple-menus-lib": "static-1.16528"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2048",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.457",
  "data-fetching-client": "/data-fetching-client/static-1.9600",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25139",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5520",
  "hs-test-utils": "/hs-test-utils/static-1.7939",
  "hub-http": "/hub-http/static-1.6146",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9789",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18020",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11386",
  "I18n": "/I18n/static-7.1606",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6394",
  "payment-link-components": "/payment-link-components/static-1.23315",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6912",
  "quartz-core": "/quartz-core/static-1.6131",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10135",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5284",
  "rich-text-lib": "/rich-text-lib/static-1.19702",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17877",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5524",
  "UIComponents": "/UIComponents/static-3.8333",
  "foundations-assets": "/foundations-assets/static-1.4778",
  "foundations-components": "/foundations-components/static-1.7784",
  "foundations-theming": "/foundations-theming/static-1.4339",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2055",
  "framer-motion": "/framer-motion/static-1.70",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.750",
  "quartz-config": "/quartz-config/static-1.690",
  "quartz-routing": "/quartz-routing/static-1.342",
  "quick-fetch": "/quick-fetch/static-1.3858",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16585",
  "react-router-dom": "/react-router-dom/static-5.26",
  "rpc-client-utils": "/rpc-client-utils/static-1.4570",
  "sanitize-text": "/sanitize-text/static-1.8070",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4695",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9470",
  "usage-tracker": "/usage-tracker/static-1.7262",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5679",
  "usage-tracker-core": "/usage-tracker-core/static-1.7112",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3343",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3189",
  "quartz-webpack": "/quartz-webpack/static-1.3136",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7586",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7851",
  "laboratory-lib": "/laboratory-lib/static-3.7084",
  "onboarding-scopes": "/onboarding-scopes/static-1.6390",
  "ui-addon-opt": "/ui-addon-opt/static-4.8306",
  "HeadJS": "/HeadJS/static-2.737",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3050",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.24",
  "ts-schema": "/ts-schema/static-1.4018",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7639",
  "cssUtils": "/cssUtils/static-1.773",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9752",
  "HubStyle": "/HubStyle/static-2.11694",
  "knowledge-content-types": "/knowledge-content-types/static-1.8472",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.587",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9812",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11076",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8968",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10074",
  "video-components-external": "/video-components-external/static-1.11035",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4250",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5956",
  "customer-data-properties": "/customer-data-properties/static-1.51277",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18283",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5009",
  "onboarding-tours": "/onboarding-tours/static-1.16460",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8017",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8977",
  "user-context": "/user-context/static-1.5026",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.822",
  "hubspotter-http": "/hubspotter-http/static-1.4592",
  "icons": "/icons/static-2.640",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.511",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.587",
  "quartz-head": "/quartz-head/static-1.577",
  "quartz-test": "/quartz-test/static-1.587",
  "quartz-tracking": "/quartz-tracking/static-1.291",
  "ui-fonts": "/ui-fonts/static-1.648",
  "usage-tracker-container": "/usage-tracker-container/static-1.7252",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9355",
  "data-token-picker": "/data-token-picker/static-1.16273",
  "FileManagerLib": "/FileManagerLib/static-1.39024",
  "property-translator": "/property-translator/static-1.5328",
  "atom": "/atom/static-1.4996",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5736",
  "salesImages": "/salesImages/static-1.523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5267",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1133",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4053",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.1601",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2822",
  "foundations-theming-base": "/foundations-theming-base/static-1.3324",
  "stylex": "/stylex/static-1.30",
  "interframe": "/interframe/static-3.4688",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5676",
  "chirp-fetch": "/chirp-fetch/static-1.1808",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4398",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3782",
  "superstore": "/superstore/static-1.4694",
  "feedback-loader": "/feedback-loader/static-1.29161",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8752",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8622",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28329",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4545",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2419",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8094",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4576",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12006",
  "content-media-compositions": "/content-media-compositions/static-2.16013",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4078",
  "magpie-lib": "/magpie-lib/static-1.5514",
  "magpie-types": "/magpie-types/static-1.4974",
  "media-bridge-lib": "/media-bridge-lib/static-1.18796",
  "video-data-lib": "/video-data-lib/static-1.34693",
  "commerce-products-lib": "/commerce-products-lib/static-1.9238",
  "crm-message-bus": "/crm-message-bus/static-1.42776",
  "growth-data-modal": "/growth-data-modal/static-1.5310",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4803",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4674",
  "calling-global-api": "/calling-global-api/static-1.64199",
  "calling-internal-common": "/calling-internal-common/static-1.31227",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65581",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57875",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3737",
  "crm-links": "/crm-links/static-1.6205",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12946",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9116",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8009",
  "external-options-client-types": "/external-options-client-types/static-1.4099",
  "file-manager-components": "/file-manager-components/static-1.23384",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6801",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.66",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3531",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4164",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.556",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3632",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48482",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3906",
  "property-value-citations": "/property-value-citations/static-1.1891",
  "pulse": "/pulse/static-1.472",
  "smart-property-lib": "/smart-property-lib/static-1.6548",
  "tiered-pricing": "/tiered-pricing/static-1.1050",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10916",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2995",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1690",
  "navigation-components": "/navigation-components/static-1.17764",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.526",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7455",
  "ui-universal-auth": "/ui-universal-auth/static-1.8881",
  "batch-promise": "/batch-promise/static-1.1478",
  "navigation-messaging": "/navigation-messaging/static-1.7091",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17401",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9787",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4948",
  "audio-components": "/audio-components/static-1.5802",
  "FileManagerCore": "/FileManagerCore/static-1.38883",
  "FileManagerImages": "/FileManagerImages/static-1.36535",
  "video-components": "/video-components/static-1.13038",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.809",
  "nav-client-types": "/nav-client-types/static-1.2283",
  "purchase-motions-api": "/purchase-motions-api/static-1.5739",
  "self-service-api": "/self-service-api/static-1.10171",
  "signup-constants": "/signup-constants/static-1.18717",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7959",
  "trials-service-types": "/trials-service-types/static-1.3827",
  "usage-tracker-public": "/usage-tracker-public/static-1.7073",
  "chatspot-core": "/chatspot-core/static-1.20939",
  "ContentUtils": "/ContentUtils/static-1.68125",
  "copilot-toolkit": "/copilot-toolkit/static-1.10923",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6508",
  "reactive-lib": "/reactive-lib/static-1.648",
  "simple-logging-lib": "/simple-logging-lib/static-1.2976",
  "commerce-permissions": "/commerce-permissions/static-1.691",
  "customer-data-tracking": "/customer-data-tracking/static-1.6810",
  "products-iframe-lib": "/products-iframe-lib/static-1.7714",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10171",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1833",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.262",
  "calling-error-reporting": "/calling-error-reporting/static-1.31233",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10963",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6466",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.691",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7175",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9011",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4083",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3950",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6706",
  "persist-promise": "/persist-promise/static-1.3635",
  "directed-graph": "/directed-graph/static-1.863",
  "event-emitter": "/event-emitter/static-1.873",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.74",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9872",
  "fsm": "/fsm/static-1.3659",
  "policy-lib": "/policy-lib/static-1.6709",
  "react-tinymce": "/react-tinymce/static-1.55024",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9935",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54150",
  "tinymce-plugins": "/tinymce-plugins/static-1.57264",
  "tinymce-themes": "/tinymce-themes/static-1.56120",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1718",
  "user-context-client": "/user-context-client/static-1.4537",
  "nest": "/nest/static-1.149",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.676",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4457",
  "video-embed": "/video-embed/static-1.35527",
  "content-icons-ui": "/content-icons-ui/static-1.2206",
  "social-insights-client-types": "/social-insights-client-types/static-1.21860",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4735",
  "integrations-lib": "/integrations-lib/static-1.15867",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4188",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14597",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35468",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3551",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4443",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2967",
  "tinymce-data": "/tinymce-data/static-1.40235",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5137",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12299",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11274",
  "react-codemirror": "/react-codemirror/static-1.10549",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14911",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9005",
  "outpost": "/outpost/static-1.4116",
  "flux-actions": "/flux-actions/static-1.326",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13282",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5522",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7711",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10299",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.395",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68200",
  "layout-data-lib": "/layout-data-lib/static-1.9599",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2934",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.13",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.104",
  "advanced-menus-core": "/advanced-menus-core/static-1.15012",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11967",
  "ExportDialog": "/ExportDialog/static-6.10317",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33833",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15011",
  "simple-menus-lib": "/simple-menus-lib/static-1.16528"
}
};
